import * as _ from 'lodash';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { TValidSdcColumns } from './../../sdc-columns.type';
import { SdcStateServiceBaseModel } from './../sdc-state-basemodel';
import { sdcStateConfigConstant } from './../sdc-state-config.constant';
import {
  IColumnSort,
  IFilter,
  IGridViews,
  ISdcActivity,
  TValidSdcStates,
  TValidSdcViews,
} from './../sdc-state.typings';

export class RegentsPlanningConfigService extends SdcStateServiceBaseModel implements ISdcActivity {
  static $inject = ['ImSchool'];

  constructor(private ImSchool: ImSchool) {
    super();
  }

  get humanName() {
    return sdcStateConfigConstant.REGENTS_PLANNING.humanName;
  }

  get state(): TValidSdcStates {
    return sdcStateConfigConstant.REGENTS_PLANNING.state;
  }

  get columns(): TValidSdcColumns[] {
    const fullColumns = [
      'studentId',
      'studentName',
      'cohort',
      'seniorFlag',
      'status',
      'regentsPlanningPriorityGrouping',
      'grade',
      'officialClass',

      // Per requirements on https://newvisions.atlassian.net/browse/PFD-7449

      // regents exemptions
      // 'countOfRegentsReqsNeededForExemptionCourseworkCompleted',
      // 'countOfRegentsReqsNeededForExemptionCourseworkInProgress',
      // 'countOfRegentsReqsNeededNotEligibleForExemption',
      // 'countOfRegentsExamsIdentifiedForExemption',
      // 'countOfRegentsExamsWithCourseworkCompleted',
      // 'countOfRegentsExamsWithCourseworkInProgress',
      // 'countOfRegentsExamsWithCourseworkInProgressDOE',
      // 'countOfRegentsExamsGreaterThan55',

      // google classroom
      'classroomRemoteEngagementLast5',
      'classroomRemoteEngagement',
      'classroomTotalAssignments',
      'classroomTotalEngagedAssignments',
      'classroomTotalEnrolled',
      'classroomStudentEmail',

      'atsCounselor',
      'advisor',
      'iep',
      'ell',
      'homeLanguage',
      'attendanceYtd',
      'gradPlan',
      'currentCourses',
      'currentCourseCodes',
      'totalCreditsEarned',
      'plannedDiplomaType',
      'plannedGraduationDate',
      // regents cats fulfilled
      'countOfRegentsPassedForDiploma',
      'regentsPassedForDiploma',
      // regents cats needed
      'countOfRegentsNeededForOnTrackDiploma',
      'regentsNeededForOnTrackDiploma',
      'regentsNotYetNeededForDiploma',
      'countOfRegentsNeededForOnTrackDiplomaNotSched',
      'regentsNeededForOnTrackDiplomaNotSched',
      'regentsNeededForOnTrackDiplomaSchedNextAdmin',
      'regentsNeededForOnTrackDiplomaSchedFutureAdmin',
      // college readiness
      'collegeReadyOnElaRegentsOrSatCr',
      'collegeReadyOnMathRegentsOrSatMath',
      'regentsNeededForCollegeReadiness',
      'regentsNeededForAdvancedRegentsDiploma',
      // regents plans
      'countOfRegentsSchedForNextAdmin',
      'regentsSchedForNextAdmin',
      'regentsSchedNextAdminAttemptedThreeOrMoreTimes',
      'countOfRegentsExamsPlannedBeyondStudentsGradDate',
      'regentsExamsPlannedBeyondStudentsGradDate',
      // conflicts
      'countOfRegentsExamsWithConclicts',
      // stars
      'countOfScheduledRegentsExamsInStarsForNextAdministration',
      'regentsSchedInStarsNextAdmin',
      'examsSchedInPortalNotPlannedInStars',
      'examsSchedInStarsNotPlannedInPortal',
      'examsToBeDroppedFromStars',
      // nysaa
      'nysaaEligible',
      // recommended not planned
      'recommendedRegentsBasedOnCulminatingCourseRationle',
      'pastDueRegentsExams',
      'pastDueUnplannedRegentsExams',
      'isRegentsRecRatCollegeReadinessMismatchedEla',
      'isRegentsRecRatCollegeReadinessMismatchedAlg',
      // max scores of 5
      'maxScoreEnglishExams',
      'maxScoreMath',
      'maxScoreScience',
      'maxScoreSs',
      'maxScorePlusOne',
      'plusOneExamName',
      // COMP ELA
      'maxScoreCompEla',
      'attCompEla',
      // CC ELA
      'maxScoreCcEla',
      'attCcEla',
      'nvRecCcEla',
      'schedInStarsCcEla',
      'nextScheduledCcEla',
      // INT ALG
      'yearStartedHsMath',
      'maxScoreIntAlg',
      'attIntAlg',
      // CC ALG
      'maxScoreCcAlg',
      'attCcAlg',
      'nvRecCcAlg',
      'schedInStarsCcAlg',
      'nextScheduledCcAlg',
      // OLD GEOM
      'maxScoreOldGeom',
      'attOldGeom',
      // CC GEOM
      'maxScoreCcGeom',
      'attCcGeom',
      'nvRecCcGeom',
      'schedInStarsCcGeom',
      'nextScheduledCcGeom',
      // OLD TRIG
      'maxScoreOldTrig',
      'attOldTrig',
      // CC TRIG
      'maxScoreCcTrig',
      'attCcTrig',
      'nvRecCcTrig',
      'schedInStarsCcTrig',
      'nextScheduledCcTrig',
      // LIVING
      'maxScoreLivingEnv',
      'attLivingEnv',
      'nvRecLivingEnv',
      'schedInStarsLivingEnv',
      'nextScheduledLivingEnv',
      // EARTH
      'maxScoreEarth',
      'attEarth',
      'nvRecEarth',
      'schedInStarsEarth',
      'nextScheduledEarth',
      // PHY SCI
      'maxScorePhysicalScience',
      'maxScoreChem',
      'attChem',
      'nvRecChem',
      'schedInStarsChem',
      'nextScheduledChem',
      // PHYSICS
      'maxScorePhysics',
      'attPhysics',
      'nvRecPhysics',
      'schedInStarsPhysics',
      'nextScheduledPhysics',
      // GLOBAL
      'maxScoreGlobal',
      'attGlobal',
      'nvRecGlobal',
      'schedInStarsGlobal',
      'nextScheduledGlobal',
      // GLOBAL II
      'maxScoreGlobalTwo',
      'attGlobalTwo',
      'nvRecGlobalTwo',
      'schedInStarsGlobalTwo',
      'nextScheduledGlobalTwo',
      // US
      'maxScoreUs',
      'attUs',
      'nvRecUs',
      'schedInStarsUs',
      'nextScheduledUs',
      // US Framework
      'maxScoreUsFramework',
      'attUsFramework',
      'nvRecUsFramework',
      'schedInStarsUsFramework',
      'nextScheduledUsFramework',
      // LOTE
      'creditsEarnedLote',
      'maxScoreLote',
      'attLote',
      'nvRecLote',
      'schedInStarsLote',
      'nextScheduledLote',
      'nextScheduledLoteExamName',
      // HIDDEN
      // needed for stars export
      'firstName',
      'lastName',
      'regentsExemptionStatusByExams',
      'examsSchedInPortalAndPlannedInStars',
      // needed for min req for grad toggle in regents planning wizard table
      'countOfRegentsPassedForGrad',
      'regentsPassedForGrad',
      'countOfRegentsNeededForOnTrackGrad',
      'regentsNeededForOnTrackGrad',
      'regentsNotYetNeededForGrad',
      'regentsNeededForOnTrackGradNotSched',
      'regentsNeededForOnTrackGradSchedNextAdmin',
      'regentsNeededForOnTrackGradSchedFutureAdmin',
      // needed for final check step
      'countOfRegentsSchedNextAdminAttemptedThreeOrMoreTimes',
      // added for community schools on 3/22
      'schoolPriorityFlag',
    ];

    return fullColumns as TValidSdcColumns[];
  }

  get hiddenColumns(): TValidSdcColumns[] {
    return [
      // needed for stars export
      'firstName',
      'lastName',
      'regentsExemptionStatusByExams',
      'examsSchedInPortalAndPlannedInStars',
      // needed for min req for grad toggle in regents planning wizard table
      'countOfRegentsPassedForGrad',
      'regentsPassedForGrad',
      'countOfRegentsNeededForOnTrackGrad',
      'regentsNeededForOnTrackGrad',
      'regentsNotYetNeededForGrad',
      'regentsNeededForOnTrackGradNotSched',
      'regentsNeededForOnTrackGradSchedNextAdmin',
      'regentsNeededForOnTrackGradSchedFutureAdmin',
      // needed for final check step
      'countOfRegentsSchedNextAdminAttemptedThreeOrMoreTimes',
    ];
  }

  get gridViews(): IGridViews {
    return {};
  }

  get filter(): IFilter {
    const school = this.getSchool();

    const filter: IFilter = {
      status: ['A'],
    };

    // Transfer schools should not be filtered by cohort
    const isTransfer = this.ImSchool.isTransferSchool(school);
    if (isTransfer) return filter;

    const seniorAndSuperCohorts = this.ImSchool.getSeniorAndSuperCohorts(school);

    let mostSeniorCohort;
    if (seniorAndSuperCohorts.length === 0) {
      mostSeniorCohort = _.min(school.uniqueCohorts);
    }

    // Otherwise return either senior + super senior cohorts, or the single most senior cohort
    const cohort = _.size(seniorAndSuperCohorts) ? seniorAndSuperCohorts : [mostSeniorCohort];

    filter.cohort = cohort;

    return filter;
  }

  get sort(): IColumnSort[] {
    return [
      { colId: 'regentsPlanningPriorityGrouping', sort: 'asc' },
      { colId: 'status', sort: 'asc' },
      { colId: 'cohort', sort: 'asc' },
      { colId: 'studentName', sort: 'asc' },
    ];
  }

  get bundleName() {
    return 'REGENTS_PLANNING';
  }

  get availableSdcViews(): TValidSdcViews[] {
    return sdcStateConfigConstant.REGENTS_PLANNING.availableSdcViews;
  }

  get imStudentMethods(): any {
    return null;
  }

  get projection() {
    return null;
  }
}
